/**
 * AdvisorSection — the B2B advisor band, extracted from LandingPage (s216) for the same reason as
 * `PricingSection`: it renders in-page at `#advisors` on the landing page AND as the `/advisors`
 * route, from one definition. Markup and inline-style values moved unchanged.
 *
 * `heading` lets `/advisors` render an `<h1>` where the landing page renders an `<h2>`.
 *
 * 🔴 `SHOW_ADVISOR_BAND` stays in LandingPage and gates the in-page mount only. The `/advisors`
 * ROUTE is not gated by it: a URL that partners are given must not disappear because a landing-page
 * layout flag flipped. Noted because the two behaving differently is deliberate, not an oversight.
 */
import { SAGE, WARM, FONT } from '@shared/brand';

export function AdvisorSection({
  onPartner,
  onSeePricing,
  heading = 'h2',
}: {
  onPartner: () => void;
  onSeePricing: () => void;
  heading?: 'h1' | 'h2';
}) {
  const Heading = heading;
  return (
    <section id="advisors" style={{ background: SAGE[800], padding: '78px 32px' }}>
      <div className="mx-auto w-full max-w-[1000px] grid items-center gap-12 grid-cols-1 min-[860px]:grid-cols-[1.2fr_0.8fr]">
        <div>
          <div style={{ fontSize: 13, fontWeight: 500, letterSpacing: '0.12em', textTransform: 'uppercase', color: SAGE[200], marginBottom: 16 }}>
            For advisors &amp; estate lawyers
          </div>
          <Heading style={{ fontFamily: FONT.serif, fontWeight: 400, fontSize: 33, lineHeight: 1.18, letterSpacing: '-0.01em', color: WARM.white, margin: '0 0 16px' }}>
            Give your clients something that outlasts the meeting.
          </Heading>
          <p style={{ fontSize: 16.5, lineHeight: 1.6, color: SAGE[100], margin: 0 }}>
            Refer clients with your own discount code — they buy on our site, under our care, and you see their progress in a private advisor dashboard. Completion status only. Never their data.
          </p>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <button onClick={onPartner} style={{ textAlign: 'center', fontSize: 15.5, color: SAGE[800], background: WARM.white, padding: 14, borderRadius: 8, fontWeight: 500, border: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
            Become a partner
          </button>
          <button onClick={onSeePricing} style={{ textAlign: 'center', fontSize: 15.5, color: WARM.white, border: '1px solid rgba(255,255,255,0.28)', padding: 14, borderRadius: 8, background: 'none', cursor: 'pointer', fontFamily: 'inherit' }}>
            See advisor pricing
          </button>
        </div>
      </div>
    </section>
  );
}
